import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { JobListing } from '../types';

interface JobCardProps {
  job: JobListing;
}

const JobCard: React.FC<JobCardProps> = ({ job }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSendResume = () => {
    const message = encodeURIComponent(job.applicationMessage);
    const phone = '66823204796';
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-foreground mb-2">{job.title}</h3>
            <div className="flex flex-wrap gap-2 mb-3">
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium">
                <Icon name="Briefcase" size={14} />
                {job.department}
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium">
                <Icon name="MapPin" size={14} />
                {job.location}
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
                <Icon name="DollarSign" size={14} />
                {job.salaryRange}
              </span>
            </div>
          </div>
        </div>

        <p className="text-gray-600 mb-4 leading-relaxed">{job.description}</p>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-primary font-medium hover:text-primary/80 transition-colors"
        >
          {isExpanded ? 'Свернуть' : 'Подробнее'}
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>

        {isExpanded && (
          <div className="mt-6 space-y-6 animate-fade-in">
            <div>
              <h4 className="font-semibold text-lg text-foreground mb-3 flex items-center gap-2">
                <Icon name="Target" size={20} className="text-primary" />
                Обязанности
              </h4>
              <ul className="space-y-2">
                {job.responsibilities.map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-700">
                    <Icon name="Check" size={18} className="text-green-500 mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-lg text-foreground mb-3 flex items-center gap-2">
                <Icon name="Users" size={20} className="text-primary" />
                Требования
              </h4>
              <ul className="space-y-2">
                {job.requirements.map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-700">
                    <Icon name="CheckCircle" size={18} className="text-blue-500 mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-lg text-foreground mb-3 flex items-center gap-2">
                <Icon name="Gift" size={20} className="text-primary" />
                Условия и преимущества
              </h4>
              <ul className="space-y-2">
                {job.benefits.map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-gray-700">
                    <Icon name="Star" size={18} className="text-yellow-500 mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="pt-6 border-t border-gray-100">
              <button
                onClick={handleSendResume}
                className="w-full flex items-center justify-center gap-2 bg-primary text-white px-6 py-4 rounded-lg font-semibold hover:bg-primary/90 transition-all transform hover:scale-105"
              >
                <Icon name="Send" size={20} />
                Откликнуться
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobCard;